import React from 'react';

import { GridFilterInputMultipleValue, GridFilterInputValue, GridFilterInputValueProps } from '@mui/x-data-grid-pro';

import { toInventoryFilterDate } from './charterInventoryFilters';

export default function InventoryDateFilterInput(props: GridFilterInputValueProps) {
  const values = props.item.operator === 'isAnyOf' ? (props.item.value ?? []) : [props.item.value];
  const invalid = values.some((value) => value && !toInventoryFilterDate(String(value)));
  const Input = props.item.operator === 'isAnyOf' ? GridFilterInputMultipleValue : GridFilterInputValue;

  return (
    <Input
      {...props}
      variant="standard"
      error={invalid}
      helperText={invalid ? 'Enter a valid date in DD/MM/YYYY.' : 'Full dates, e.g. 18/10/2026.'}
    />
  );
}

// MUI resets the value when input component identity changes between single and multiple dates.
export function InventoryDateFilterMultipleInput(props: GridFilterInputValueProps) {
  return <InventoryDateFilterInput {...props} />;
}
